import { createSlice } from "@reduxjs/toolkit";

const UserLevelSlice = createSlice({
    name: "UserLevel",
    initialState: 2,
    reducers: {
        setUserLevel: (state, action) => {
            return action.payload
        },
    },
});

export const { setUserLevel } = UserLevelSlice.actions;

export default UserLevelSlice.reducer;